module.exports = __webpack_public_path__ + "img/secKillYinHe.3d84055f.jpg";